import { SERVER } from "../environment.constants";

export class JoinUrl {
    public static join: string = SERVER + "/join";
}